<template>
  <grid-container-fi
    :container="false"
    class="no-products-found-fi"
  >
    <div class="no-products-found-fi__no-results">
      <div class="no-products-found-fi__no-results__headline">
        {{ $dict.get('product-List.No-Products-Found.Headline') }}
      </div>
      <img
        :src="noProductSearchResultImg"
        :alt="$dict.get('product-List.No-Products-Found.Headline')"
        class="no-products-found-fi__no-results__image"
      />
      <div class="no-products-found-fi__no-results__text">
        {{ $dict.get('product-List.No-Products-Found.Text') }}
      </div>
    </div>
  </grid-container-fi>
</template>

<script setup lang="ts">
import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';
import { useAssetUrl } from '@/composables/assetUrl';

const { getAssetUrl } = useAssetUrl();
const noProductSearchResultImg: string = getAssetUrl(
  '/img/search-suggestions/no-search-results.svg',
);
</script>

<style scoped src="./no-products-found-fi" />
